@import "src/styles/variabels";

.root{
  width: 6rem;
  height: 2rem;
  border: 1px solid $color-secondary;
  padding: .1rem;
  border-radius: .2rem;
  position: relative;
}
.color {
  width: 100%;
  height: 100%;
  display: inline-flex;
}
